/* PCP product page (26-9-2026): gallery + zoom + keyboard thumbs, variant select, pack quantity
   helper, AJAX add-to-basket with loading/success/error states, trade-quote link that carries
   the pack quantity, accessible tabs, sticky buy bar, recently viewed. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pcp]');
  if (!root) return;
  var moneyFmt = root.getAttribute('data-money-format') || '£' + '{' + '{amount}' + '}';
  var pack = parseInt(root.getAttribute('data-pack'), 10) || 0;
  var noun = root.getAttribute('data-noun') || 'piece';
  var handle = root.getAttribute('data-handle');
  var form = document.getElementById('pcp-form');
  var qtyInput = root.querySelector('[data-pcp-qty-input]');
  var variantInput = root.querySelector('[data-pcp-variant-id]');
  var amountEl = root.querySelector('[data-pcp-amount]');
  var perEl = root.querySelector('[data-pcp-per]');
  var errEl = root.querySelector('[data-pcp-error]');
  var quoteLink = root.querySelector('[data-pcp-quote]');
  var toast = root.querySelector('[data-pcp-toast]');
  var toastTimer = null;
  var variants = null;
  var priceCents = 0;

  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    var s = n.toFixed(2), parts = s.split('.'), whole = parts[0], out = '';
    while (whole.length > 3) { out = ',' + whole.slice(-3) + out; whole = whole.slice(0, -3); }
    var amount = whole + out + '.' + parts[1];
    var f = moneyFmt;
    f = f.split('{' + '{amount}' + '}').join(amount);
    f = f.split('{' + '{amount_no_decimals}' + '}').join(whole + out);
    f = f.split('{' + '{amount_with_comma_separator}' + '}').join(amount.split('.').join(','));
    return f;
  }
  function moneyShort(cents) { return money(cents).split(' (Inc')[0]; }
  function parseMoney(text) {
    var m = String(text || '').replace(/,/g, '').match(/([0-9]+)[.]([0-9]{2})/);
    return m ? parseInt(m[1], 10) * 100 + parseInt(m[2], 10) : 0;
  }
  priceCents = parseMoney(amountEl ? amountEl.textContent : '');

  /* ---------- gallery ---------- */
  var mainWrap = qs('[data-pcp-zoom]');
  var mainImg = document.getElementById('pcp-main-img');
  var thumbs = qsa('[data-pcp-thumb]');
  function showThumb(btn) {
    if (!mainImg || !btn) return;
    mainImg.setAttribute('src', btn.getAttribute('data-src'));
    mainImg.setAttribute('srcset', btn.getAttribute('data-srcset'));
    mainImg.setAttribute('alt', btn.getAttribute('data-alt') || '');
    thumbs.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (mainWrap) mainWrap.classList.remove('is-zoomed');
  }
  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { showThumb(btn); });
    btn.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = thumbs[i + 1] || thumbs[0];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = thumbs[i - 1] || thumbs[thumbs.length - 1];
      if (next) { e.preventDefault(); next.focus(); showThumb(next); }
    });
  });
  if (mainWrap && mainImg && window.matchMedia('(hover: hover)').matches) {
    mainWrap.addEventListener('click', function () { mainWrap.classList.toggle('is-zoomed'); });
    mainWrap.addEventListener('mousemove', function (e) {
      if (!mainWrap.classList.contains('is-zoomed')) return;
      var r = mainWrap.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
    });
    mainWrap.addEventListener('mouseleave', function () { mainWrap.classList.remove('is-zoomed'); });
  }

  /* ---------- variants (only when the product has options) ---------- */
  var vScript = qs('[data-pcp-variants]');
  if (vScript) { try { variants = JSON.parse(vScript.textContent); } catch (err) { variants = null; } }
  function currentVariant() {
    if (!variants) return null;
    var sel = qsa('[data-pcp-option]').map(function (s) { return s.value; });
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
      if (ok) return variants[i];
    }
    return null;
  }
  function setAvailability(available) {
    var add = qs('[data-pcp-add]');
    var stickyAdd = qs('[data-pcp-sticky-add]');
    var avail = qs('[data-pcp-avail]');
    if (add) { add.disabled = !available; add.querySelector('.pcp-add__label').textContent = available ? 'Add to basket' : 'Out of stock'; }
    if (stickyAdd) { stickyAdd.disabled = !available; stickyAdd.textContent = available ? 'Add to basket' : 'Out of stock'; }
    if (avail) {
      avail.classList.remove('is-in', 'is-order', 'is-out');
      avail.classList.add(available ? 'is-order' : 'is-out');
      avail.lastChild.textContent = available ? 'In stock - ready to ship' : 'Out of stock';
    }
  }
  qsa('[data-pcp-option]').forEach(function (s) {
    s.addEventListener('change', function () {
      var v = currentVariant();
      if (!v) { setAvailability(false); return; }
      if (variantInput) variantInput.value = v.id;
      priceCents = v.price;
      if (amountEl) amountEl.textContent = moneyShort(v.price);
      if (perEl && pack > 1) perEl.textContent = moneyShort(Math.round(v.price / pack));
      var sp = qs('[data-pcp-sticky-price]');
      if (sp) sp.textContent = moneyShort(v.price);
      setAvailability(!!v.available);
      if (v.featured_image && v.featured_image.src && mainImg) { mainImg.setAttribute('src', v.featured_image.src); mainImg.removeAttribute('srcset'); }
      updateHelp();
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (err) {}
    });
  });

  /* ---------- quantity helper + trade-quote link ---------- */
  function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
  function updateHelp() {
    var q = qty();
    var n = qs('[data-pcp-qty-n]');
    var pieces = qs('[data-pcp-pieces]');
    var line = qs('[data-pcp-line]');
    if (n) n.textContent = q;
    var w = qs('[data-pcp-qty-word]');
    if (w) w.textContent = q === 1 ? 'pack' : 'packs';
    if (pieces && pack > 1) pieces.textContent = (q * pack).toLocaleString('en-GB');
    if (line) line.textContent = moneyShort(priceCents * q);
    if (quoteLink) {
      var base = quoteLink.getAttribute('data-pcp-quote-base');
      if (base) quoteLink.setAttribute('href', base + '&packs=' + q);
    }
    if (errEl && !errEl.hidden) { errEl.hidden = true; }
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pcp-qty]');
    if (b && qtyInput) {
      var next = qty() + parseInt(b.getAttribute('data-pcp-qty'), 10);
      qtyInput.value = Math.max(1, next);
      updateHelp();
    }
  });
  if (qtyInput) {
    qtyInput.addEventListener('input', updateHelp);
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); updateHelp(); });
  }
  updateHelp();

  /* ---------- add to basket ---------- */
  function showToast(text, isError) {
    if (!toast) return;
    var t = toast.querySelector('[data-pcp-toast-text]');
    if (t) t.textContent = text;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  function showError(msg) {
    if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    showToast(msg, true);
  }
  function addToCart() {
    if (!form) return;
    var add = qs('[data-pcp-add]');
    if (add && (add.classList.contains('is-busy') || add.disabled)) return;
    if (add) { add.classList.add('is-busy'); add.classList.remove('is-error'); add.setAttribute('aria-busy', 'true'); }
    if (qtyInput) qtyInput.value = qty();
    var fd = new FormData(form);
    var q = qty();
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (add) { add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); }
        if (!res.ok) {
          if (add) { add.classList.add('is-error'); setTimeout(function () { add.classList.remove('is-error'); }, 2500); }
          showError(res.body && res.body.description ? res.body.description : 'Could not add to basket — please try again');
          return;
        }
        if (add) { add.classList.add('is-done'); setTimeout(function () { add.classList.remove('is-done'); }, 2200); }
        var msg = pack > 1 ? (q + (q === 1 ? ' pack' : ' packs') + ' (' + (q * pack) + ' ' + noun + 's) added to basket') : (q > 1 ? q + ' added to basket' : 'Added to basket');
        showToast(msg);
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'pcp' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pcp' } }));
      })
      .catch(function () {
        if (add) { add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); add.classList.add('is-error'); setTimeout(function () { add.classList.remove('is-error'); }, 2500); }
        showError('Could not add to basket — please check your connection and try again');
      });
  }
  if (form) form.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    addToCart();
  });
  var stickyAddBtn = qs('[data-pcp-sticky-add]');
  if (stickyAddBtn) stickyAddBtn.addEventListener('click', addToCart);

  /* ---------- tabs (roving tabindex, arrow keys, Home/End) ---------- */
  var tabs = qsa('[data-pcp-tab]');
  function activate(name, focus) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-pcp-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && focus) t.focus();
    });
    qsa('[data-pcp-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pcp-panel') === name); });
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(t.getAttribute('data-pcp-tab'), false); });
    t.addEventListener('keydown', function (e) {
      var target = null;
      if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') target = tabs[0];
      else if (e.key === 'End') target = tabs[tabs.length - 1];
      if (target) { e.preventDefault(); activate(target.getAttribute('data-pcp-tab'), true); }
    });
  });

  /* ---------- sticky bar ---------- */
  var sticky = qs('[data-pcp-sticky]');
  var addBtn = qs('[data-pcp-add]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      var show = !e.isIntersecting && below;
      sticky.hidden = !show;
      sticky.classList.toggle('is-visible', show);
    }, { threshold: 0 });
    io.observe(addBtn);
  }

  /* ---------- recently viewed ---------- */
  var KEY = 'pcp-recent';
  var recent = [];
  try { recent = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (err) { recent = []; }
  var others = recent.filter(function (h) { return h !== handle; });
  try { localStorage.setItem(KEY, JSON.stringify([handle].concat(others).slice(0, 12))); } catch (err) {}
  var recentSection = document.querySelector('[data-pcp-recent]');
  var recentList = document.querySelector('[data-pcp-recent-list]');
  var clearBtn = document.querySelector('[data-pcp-recent-clear]');
  function shortTitle(t) {
    return String(t || '').split(' (Pack of')[0].split(' - Pack of')[0].split(' – Pack of')[0];
  }
  if (recentSection && recentList && others.length) {
    Promise.all(others.slice(0, 8).map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = '';
      items.forEach(function (p) {
        if (!p) return;
        var pk = 0;
        var m = p.title.match(/Pack of ([0-9]+)/);
        if (m) pk = parseInt(m[1], 10);
        var img = p.featured_image ? p.featured_image.split('?')[0] + '?width=480' : '';
        html += '<li class="pcp-card"><a href="/products/' + esc(p.handle) + '" class="pcp-card__media">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(shortTitle(p.title)) + '" loading="lazy" width="480" height="480">' : '') +
          (pk > 1 ? '<span class="pcp-card__pack">Pack of ' + pk + '</span>' : '') + '</a>' +
          '<div class="pcp-card__body">' + (p.type ? '<span class="pcp-card__type">' + esc(p.type) + '</span>' : '') +
          '<h3 class="pcp-card__title"><a href="/products/' + esc(p.handle) + '">' + esc(shortTitle(p.title)) + '</a></h3>' +
          '<div class="pcp-card__price"><span>' + esc(moneyShort(p.price)) + '</span></div></div></li>';
      });
      if (html) { recentList.innerHTML = html; recentSection.hidden = false; }
    });
  }
  if (clearBtn) clearBtn.addEventListener('click', function () {
    try { localStorage.removeItem(KEY); } catch (err) {}
    if (recentSection) recentSection.hidden = true;
  });
})();